import { GtmEvents } from '@/gtm/gtm-events';

export class PromotionsGtmEvents extends GtmEvents {
  eventCategory = 'СобытияЛК';

  onShowPromotionsPage() {
    return this.gtmEvent({
      eventAction: 'ЛК_Уведомления_ПросмотрСтраницы',
    });
  }

  onClickMoreDetailedBtn(promocode) {
    return this.gtmEvent({
      eventAction: 'ЛК_Уведомления_ПерсональныеПредложения_Подробнее',
      eventLabel: JSON.stringify({
        promocode,
      }),
    });
  }

  onClickCopyBtn(promocode) {
    return this.gtmEvent({
      eventAction: 'ЛК_Уведомления_ПерсональныеПредложения_Скопировать',
      eventLabel: JSON.stringify({
        promocode,
      }),
    });
  }

  onClickNotificationsTab(name) {
    return this.gtmEvent({
      eventAction: 'ЛК_Уведомления_ВкладкаКлик',
      eventLabel: JSON.stringify({
        list: name,
      }),
    });
  }

  onClickNotificationsShowAllLink() {
    return this.gtmEvent({
      eventAction: 'ЛК_Уведомления_ПосмотретьВсе',
    });
  }

  onClickAllNotificationsAsRead() {
    return this.gtmEvent({
      eventAction: 'ЛК_Уведомления_ОтметитьВсеПрочитанным',
    });
  }

  onClickNotificationsAsRead() {
    return this.gtmEvent({
      eventAction: 'ЛК_Уведомления_ОтметитьПрочитанным',
    });
  }

  onClickNotificationsBellLink() {
    return this.gtmEvent({
      eventAction: 'ЛК_Уведомления_КолоколКлик',
    });
  }
}

export const promotionsGtmEvents = new PromotionsGtmEvents();
